/**
 * Static client-side config.
 * Business rules that change at runtime live in the `system_config` table —
 * fetch via the `get_config_int` / `get_config_text` RPCs in edge functions.
 */

export const APP_ENV = import.meta.env?.VITE_APP_ENV ?? 'development';

export const PHONE_COUNTRY_CODE = '+260';
export const PHONE_REGEX = /^\+260[0-9]{9}$/;
export const NRC_REGEX = /^[0-9]{6}\/[0-9]{2}\/[0-9]$/;

export const OTP_LENGTH = 6;
export const OTP_REQUEST_COOLDOWN_SECONDS = 60;
export const OTP_EXPIRY_SECONDS = 300;

export const LOAN_TERM_DAYS = [14, 30, 60, 90] as const;
export type LoanTermDays = (typeof LOAN_TERM_DAYS)[number];

export const SUPPORTED_MM_PROVIDERS = [
  'mtn_momo',
  'airtel_money',
  'zamtel_kwacha',
] as const;
export type MobileMoneyProvider = (typeof SUPPORTED_MM_PROVIDERS)[number];

export const PROVIDER_DISPLAY_NAME: Record<MobileMoneyProvider, string> = {
  mtn_momo: 'MTN Mobile Money',
  airtel_money: 'Airtel Money',
  zamtel_kwacha: 'Zamtel Kwacha',
};
